import { useState } from 'react';

import AllTenantsAudit from '../components/AdminAudit/AllTenantsAudit';
import TenantOnboardingForm from '../components/AdminAudit/TenantOnboardingForm';

const TABS = [
  {
    key: 'onboarding',
    label: 'Tenant Onboarding'
  },
  {
    key: 'all-admins',
    label: 'Manage Tenants'
  }
];

const TenantAudit = () => {
  const [activeTab, setActiveTab] = useState('onboarding');

  return (
    <div className='p-6'>
      <div className='rounded-lg border border-gray-200 bg-white shadow-sm'>
        <div className='sticky top-0 z-10 border-b border-gray-100 bg-white/60 backdrop-blur-md'>
          <nav
            role='tablist'
            aria-label='Admin audit tabs'
            className='flex gap-2 px-4 py-3'
          >
            {TABS.map(tab => {
              const active = activeTab === tab.key;
              return (
                <button
                  key={tab.key}
                  role='tab'
                  aria-selected={active}
                  tabIndex={active ? 0 : -1}
                  onClick={() => setActiveTab(tab.key)}
                  onKeyDown={e => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      e.preventDefault();
                      setActiveTab(tab.key);
                    }
                  }}
                  className={`flex flex-col items-start gap-1 rounded-t-md px-4 py-2 transition-all focus:outline-none ${
                    active
                      ? 'border border-b-white bg-white text-blue-600 shadow-sm'
                      : 'text-gray-600 hover:bg-gray-50 hover:text-gray-800'
                  }`}
                >
                  <span className='text-sm font-medium'>{tab.label}</span>
                </button>
              );
            })}
          </nav>
        </div>

        <div className=''>
          {activeTab === 'onboarding' && <TenantOnboardingForm />}
          {activeTab === 'all-admins' && <AllTenantsAudit />}
        </div>
      </div>
    </div>
  );
};

export default TenantAudit;
